import React from "react";
import { Helmet } from "react-helmet";

export default function Privacy() {
  return (
    <main style={{ maxWidth: 900, margin: "48px auto", padding: "0 20px", lineHeight: 1.6 }}>
      <Helmet>
        <title>Privacy Policy | LSSI Fin</title>
        <meta name="description" content="Privacy Policy for the LSSI Fin QuickBooks Online integration." />
      </Helmet>

      <h1>Privacy Policy</h1>
      <p style={{ color: "#555" }}>Last updated: November 2025</p>

      <h2>1. Information We Collect</h2>
      <ul>
        <li><b>OAuth/Account:</b> Tokens and basic identifiers (e.g., QBO realm ID) to keep your connection.</li>
        <li><b>QBO Data:</b> Accessed only as needed to provide requested features; data remains your property.</li>
        <li><b>Operational Logs:</b> Minimal technical metadata for support/security.</li>
      </ul>

      <h2>2. How We Use It</h2>
      <ul>
        <li>Operate requested features; improve performance; secure and troubleshoot.</li>
        <li>Send important notices about service or incidents.</li>
      </ul>

      <h2>3. Sharing & Disclosure</h2>
      <ul>
        <li>No selling or renting of data.</li>
        <li>Service providers under confidentiality may process data (e.g., hosting).</li>
        <li>Disclosures required by law or to protect rights/safety.</li>
      </ul>

      <h2>4. Security</h2>
      <p>HTTPS and industry-standard controls protect tokens and data (no method is 100% secure).</p>

      <h2>5. Retention</h2>
      <p>Tokens/metadata retained while connected; deleted after disconnecting the integration.</p>

      <h2>6. Your Choices</h2>
      <ul>
        <li>Disconnect at any time from the App or your Intuit account.</li>
        <li>Email us to request deletion of stored tokens/metadata.</li>
      </ul>

      <h2>7. International Transfers</h2>
      <p>Data may be processed where our providers operate; we take appropriate safeguards.</p>

      <h2>8. Children</h2>
      <p>Not directed to children under 13; we do not knowingly collect such data.</p>

      <h2>9. Changes</h2>
      <p>We’ll post updates here with a new “Last updated” date.</p>

      <h2>10. Contact</h2>
      <p><a href="mailto:info@lssi-fin.com">info@lssi-fin.com</a></p>
    </main>
  );
}